import { IUrls, ServiceProviderType } from 'api-paths-cas';
import { UserRole } from '../../store/auth/types';

export enum P {
  EDIT_APPLY_OFFER = '@@perm/APPLY/EDIT_APPLY_OFFER',
  EDIT_APPLY_APPLICANT_DETAILS = '@@perm/APPLY/EDIT_APPLY_APPLICANT_DETAILS',
  EDIT_APPLY_SUBMITTED_APPLICANT_DETAILS = '@@perm/APPLY/EDIT_APPLY_SUBMITTED_APPLICANT_DETAILS',
  EDIT_APPLY_LOCKED_APPLICATIONS = '@@perm/APPLY/EDIT_APPLY_LOCKED_APPLICATIONS',
  EDIT_APPLY_TAGS = '@@perm/APPLY/EDIT_APPLY_TAGS',
  CREATE_APPLY_APPLICATION = '@@perm/APPLY/CREATE_APPLY_APPLICATION',

  AGENT_VIEW = '@@perm/AGENT_VIEW',
  CONFIDENCE_SCORE_VIEW = '@@perm/CONFIDENCE_SCORE_VIEW',
  LAST_TOUCH_VIEW = '@@perm/LAST_TOUCH_VIEW',
  TAGS_VIEW = '@@perm/TAGS_VIEW',
  TAGS_DELETE = '@@perm/TAGS_DELETE',
  UNIVERSITY_VIEW = '@@perm/UNIVERSITY_VIEW',
  MULTI_UNIVERSITY_VIEW = '@@perm/MULTI_UNIVERSITY_VIEW',
  VIEW_INSTITUTION_DROPDOWN = '@@perm/VIEW_INSTITUTION_DROPDOWN',
  VIEW_ACTION_DROPDOWN = '@@perm/VIEW_ACTION_DROPDOWN',
  STUDENT_STATUS_EDIT = '@@perm/STUDENT_STATUS_EDIT',
  STUDENTS_EXPORTS = '@@perm/STUDENTS_EXPORTS',

  CHECKLIST_VIEW = '@@perm/CHECKLIST_VIEW',
  CHECKLIST_EDIT = '@@perm/CHECKLIST_EDIT',
  CHECKLIST_FLAGS = '@@perm/CHECKLIST_FLAGS',
  CHECKLIST_NAVIGATE_FORWARD = '@@perm/CHECKLIST_NAVIGATE_FORWARD',

  ALL_DOCUMENTS_PREVIEW = '@@perm/ALL_DOCUMENTS_PREVIEW',
  ALL_DOCUMENTS_DOWNLOAD = '@@perm/ALL_DOCUMENTS_DOWNLOAD',
  ALL_DOCUMENTS_APPROVE = '@@perm/ALL_DOCUMENTS_APPROVE',
  ALL_DOCUMENTS_REJECT = '@@perm/ALL_DOCUMENTS_REJECT',
  ALL_DOCUMENTS_ACKNOWLEDGE = '@@perm/ALL_DOCUMENTS_ACKNOWLEDGE',
  ALL_DOCUMENTS_VIEW_APPROVAL = '@@perm/ALL_DOCUMENTS_VIEW_APPROVAL',
  ALL_DOCUMENTS_VIEW_REJECTION = '@@perm/ALL_DOCUMENTS_VIEW_REJECTION',

  GENERAL_DOCUMENTS_VIEW = '@@perm/GENERAL_DOCUMENTS_VIEW',
  GENERAL_DOCUMENTS_UPLOAD = '@@perm/GENERAL_DOCUMENTS_UPLOAD',
  GENERAL_DOCUMENTS_FLAGS = '@@perm/GENERAL_DOCUMENTS_FLAGS',
  GENERAL_DOCUMENTS_DELETE = '@@perm/GENERAL_DOCUMENTS_DELETE',

  CHECK_OFF_RISKS = '@@perm/CHECK_OFF_RISKS',

  FINANCE_DOCUMENTS_VIEW = '@@perm/FINANCE_DOCUMENTS_VIEW',
  FINANCE_DOCUMENTS_UPLOAD = '@@perm/FINANCE_DOCUMENTS_UPLOAD',
  FINANCE_DOCUMENTS_FLAGS = '@@perm/FINANCE_DOCUMENTS_FLAGS',
  FINANCE_DOCUMENTS_DELETE = '@@perm/FINANCE_DOCUMENTS_DELETE',

  FOLLOW_UP_DOCUMENTS_VIEW = '@@perm/FOLLOW_UP_DOCUMENTS_VIEW',
  FOLLOW_UP_DOCUMENTS_UPLOAD = '@@perm/FOLLOW_UP_DOCUMENTS_UPLOAD',
  FOLLOW_UP_DOCUMENTS_DELETE = '@@perm/FOLLOW_UP_DOCUMENTS_DELETE',

  CUSTOM_DOCUMENTS_REQUEST = '@@perm/CUSTOM_DOCUMENTS_REQUEST',
  PRE_CAS_INTERVIEW_VIEW = '@@perm/PRE_CAS_INTERVIEW_VIEW',
  PRE_CAS_INTERVIEW_EDIT = '@@perm/PRE_CAS_INTERVIEW_EDIT',
  PRE_CAS_INTERVIEW_RESET = '@@perm/PRE_CAS_INTERVIEW_RESET',
  PRE_CAS_INTERVIEW_FLAGS = '@@perm/PRE_CAS_INTERVIEW_FLAGS',
  VISA_PREP_VIEW = '@@perm/VISA_PREP_VIEW',
  VISA_PREP_EDIT = '@@perm/VISA_PREP_EDIT',
  VISA_PREP_UNLOCK = '@@perm/VISA_PREP_UNLOCK',
  VIEW_CONFIG = '@@perm/VIEW_CONFIG',
  VIEW_INSIGHTS = '@@perm/VIEW_INSIGHTS',
  ADVANCED_USER_MANAGEMENT = '@@perm/ADVANCED_USER_MANAGEMENT',
  USER_MANAGEMENT = '@@perm/USER_MANAGEMENT',
  EDIT_RISK_REGION = '@@perm/EDIT_RISK_REGION',
  EDIT_CUSTOM_DOCUMENTS = '@@perm/EDIT_CUSTOM_DOCUMENTS',
  EDIT_REGION_OFFICE = '@@perm/EDIT_REGION_OFFICE',
  EDIT_AGENCY_ALIASES = '@@perm/EDIT_AGENCY_ALIASES',
  EDIT_TAGS = '@@perm/EDIT_TAGS',
  EDIT_PROGRAMMABLE_TAGS = '@@perm/EDIT_PROGRAMMABLE_TAGS',
  IMPORT_STUDENTS = '@@perm/IMPORT_STUDENTS',
  EDIT_CONFIG = '@@perm/EDIT_CONFIG',
  EDIT_FIELD_MAPPING = '@@perm/EDIT_FIELD_MAPPING',
  CAS_INFO_VIEW = '@@perm/CAS_INFO_VIEW',
  MANAGE_AGENTS = '@@perm/MANAGE_AGENTS',
  MANAGE_AGENCIES = '@@perm/MANAGE_AGENCIES',
  EDIT_OPTIONAL_AGENCY_FIELDS = '@@perm/EDIT_OPTIONAL_AGENCY_FIELDS',
  BLOCK_CREATE_APPLICATION = '@@perm/BLOCK_CREATE_APPLICATION',
  ADD_AGENCY_NOTE = '@@perm/ADD_AGENCY_NOTE',
  VIEW_ALL_DATA = '@@perm/VIEW_ALL_DATA',
  VIEW_CAS_TRACKER = '@@perm/VIEW_CAS_TRACKER',
  VIEW_AUDIT_LOG = '@@perm/VIEW_AUDIT_LOG',
  MANAGE_INTEGRATIONS = '@@perm/MANAGE_INTEGRATIONS',
  MANAGE_HOOKS = '@@perm/MANAGE_HOOKS',
  MANAGE_CALENDLY = '@@perm/MANAGE_CALENDLY',
  SPECIAL_MAPS = '@@SPECIAL_MAPS',
  SPECIAL_RULES = '@@SPECIAL_RULES',
  MANAGE_SYSTEM_CONFIG = '@@perm/MANAGE_SYSTEM_CONFIG',
  VIEW_ADMIN_ACTION_DROPDOWN = '@@perm/VIEW_ADMIN_ACTION_DROPDOWN',
  UPLOAD_STAFF_ONLY_DOCS = '@@perm/UPLOAD_STAFF_ONLY_DOCS',
  UPLOAD_AGENT_ONLY_DOCS = '@@perm/UPLOAD_AGENT_ONLY_DOCS',
  RESEND_RESET_PASSWORD = '@@perm/RESEND_REST_PASSWORD',
  EDIT_STUDENT_SERVICES = '@@perm/EDIT_STUDENT_SERVICES',
  EDIT_STUDENT_IMMIGRATION_PROVIDERS = '@@perm/EDIT_STUDENT_IMMIGRATION_PROVIDERS',
  RESET_MFA = '@@parm/RESET_MFA',
  ASSIGN_VISA_SUPPORT = '@@perm/ASSIGN_VISA_SUPPORT',
  UNASSIGN_VISA_SUPPORT = '@@perm/UNASSIGN_VISA_SUPPORT',
  NOT_INVITED = '@@perm/NOT_INVITED',
  CAN_DELETE_FILE = '@@perm/CAN_DELETE_FILE',
  SCHEDULED_INTERVIEWS_REQUEST = '@@perm/SCHEDULED_INTERVIEWS_REQUEST',
  SCHEDULED_INTERVIEWS_CANCEL = '@@perm/SCHEDULED_INTERVIEWS_CANCEL',
  CHANGE_WORKFLOW = '@@perm/CHANGE_WORKFLOW',
  FILTER_AGENTS = '@@perm/FILTER_AGENTS',
  FILTER_CONFIDENCE = '@@perm/FILTER_CONFIDENCE',
  FILTER_SERVICES = '@@perm/FILTER_SERVICES',
  FILTER_IMM_PROV = '@@perm/FILTER_IMM_PROV',
  FILTER_CONDITIONAL_STATUS = '@@perm/FILTER_COND_STATUS',
  FILTER_COURSE_CONDITION_STATUS = '@@perm/FILTER_COURSE_COND_STATUS',
  FILTER_TAGS_STATUS = '@@perm/FILTER_TAGS_STATUS',
  FILTER_PROG_TAGS = '@@perm/FILTER_PROG_TAGS',
  FILTER_UNIVERSITY = '@@perm/FILTER_UNIVERSITY',
  FILTER_RISK_REGION = '@@perm/FILTER_RISK_REGION',
  FILTER_DEPENDANTS = '@@perm/FILTER_DEPENDANTS',
  LATE_ARRIVAL_VIEW = '@@perm/LATE_ARRIVAL_VIEW',
  RECORDED_INTERVIEWS_CANCEL = '@perm/RECORDED_INTERVIEWS_CANCEL',
  DAYS_IN_STAGE = '@perm/DAYS_IN_STAGE',

  AI_INTERVIEW_ASSESSMENT_SCORES_VIEW = '@@perm/AI_INTERVIEW_ASSESSMENT_SCORES_VIEW',
  AI_INTERVIEW_ASSESSMENT_SCORES_EDIT = '@@perm/AI_INTERVIEW_ASSESSMENT_SCORES_EDIT',

  SCHEDULED_INTERVIEWS_VIEW = '@@perm/SCHEDULED_INTERVIEWS_VIEW',
  SCHEDULED_INTERVIEWS_ATTACH = '@@perm/SCHEDULED_INTERVIEWS_ATTACH',
  SCHEDULED_INTERVIEWS_PREVIEW = '@@perm/SCHEDULED_INTERVIEWS_PREVIEW',
  SCHEDULED_INTERVIEWS_PASS = '@@perm/SCHEDULED_INTERVIEWS_PASS',
  SCHEDULED_INTERVIEWS_RESIT = '@@perm/SCHEDULED_INTERVIEWS_RESIT',
  SCHEDULED_INTERVIEWS_FAIL = '@@perm/SCHEDULED_INTERVIEWS_FAIL',

  RECORDED_INTERVIEW_VIEW = '@@perm/RECORDED_INTERVIEW_VIEW',
  RECORDED_INTERVIEW_ATTACH = '@@perm/RECORDED_INTERVIEW_ATTACH',
  RECORDED_INTERVIEW_PREVIEW = '@@perm/RECORDED_INTERVIEW_PREVIEW',
  RECORDED_INTERVIEW_PASS = '@@perm/RECORDED_INTERVIEW_PASS',
  RECORDED_INTERVIEW_RESIT = '@@perm/RECORDED_INTERVIEW_RESIT',
  RECORDED_INTERVIEW_FAIL = '@@perm/RECORDED_INTERVIEW_FAIL',
  RECORDED_INTERVIEW_REQUEST = '@@perm/RECORDED_INTERVIEW_REQUEST',
  RECORDED_INTERVIEW_CANCEL = '@@perm/RECORDED_INTERVIEW_CANCEL',
}

const Permissions: {
  [key: string]: P[];
} = {
  [UserRole.Admin]: [
    P.CREATE_APPLY_APPLICATION,
    P.EDIT_APPLY_APPLICANT_DETAILS,
    P.EDIT_APPLY_SUBMITTED_APPLICANT_DETAILS,
    P.EDIT_APPLY_LOCKED_APPLICATIONS,
    P.EDIT_APPLY_OFFER,
    P.EDIT_APPLY_TAGS,
    P.AGENT_VIEW,
    P.CONFIDENCE_SCORE_VIEW,
    P.LAST_TOUCH_VIEW,
    P.TAGS_VIEW,
    P.TAGS_DELETE,
    P.EDIT_TAGS,
    P.UNIVERSITY_VIEW,
    P.MULTI_UNIVERSITY_VIEW,
    P.VIEW_INSTITUTION_DROPDOWN,
    P.VIEW_ACTION_DROPDOWN,
    P.STUDENT_STATUS_EDIT,
    P.STUDENTS_EXPORTS,
    P.VIEW_CONFIG,
    P.VIEW_INSIGHTS,
    P.ADVANCED_USER_MANAGEMENT,
    P.IMPORT_STUDENTS,
    P.EDIT_CONFIG,
    P.EDIT_FIELD_MAPPING,
    P.CAS_INFO_VIEW,
    P.MANAGE_AGENTS,
    P.EDIT_AGENCY_ALIASES,
    P.VIEW_ALL_DATA,
    P.EDIT_RISK_REGION,
    P.EDIT_CUSTOM_DOCUMENTS,
    P.EDIT_REGION_OFFICE,
    P.EDIT_TAGS,
    P.EDIT_PROGRAMMABLE_TAGS,
    P.VIEW_AUDIT_LOG,
    P.CHECK_OFF_RISKS,
    P.MANAGE_INTEGRATIONS,
    P.MANAGE_HOOKS,
    P.MANAGE_CALENDLY,
    P.SPECIAL_MAPS,
    P.SPECIAL_RULES,
    P.MANAGE_SYSTEM_CONFIG,
    P.VIEW_ADMIN_ACTION_DROPDOWN,
    P.UPLOAD_STAFF_ONLY_DOCS,
    P.UPLOAD_AGENT_ONLY_DOCS,
    P.RESEND_RESET_PASSWORD,
    P.EDIT_STUDENT_SERVICES,
    P.EDIT_STUDENT_IMMIGRATION_PROVIDERS,
    P.RESET_MFA,
    P.ASSIGN_VISA_SUPPORT,
    P.UNASSIGN_VISA_SUPPORT,
    P.NOT_INVITED,
    P.SCHEDULED_INTERVIEWS_REQUEST,
    P.SCHEDULED_INTERVIEWS_CANCEL,
    P.CHANGE_WORKFLOW,
    P.FILTER_AGENTS,
    P.FILTER_CONFIDENCE,
    P.FILTER_SERVICES,
    P.FILTER_IMM_PROV,
    P.FILTER_CONDITIONAL_STATUS,
    P.FILTER_COURSE_CONDITION_STATUS,
    P.FILTER_TAGS_STATUS,
    P.FILTER_PROG_TAGS,
    P.FILTER_UNIVERSITY,
    P.FILTER_DEPENDANTS,
    P.FILTER_RISK_REGION,
    P.LATE_ARRIVAL_VIEW,
    P.RECORDED_INTERVIEWS_CANCEL,
    P.DAYS_IN_STAGE,

    //student
    P.EDIT_OPTIONAL_AGENCY_FIELDS,
    P.BLOCK_CREATE_APPLICATION,
    P.ADD_AGENCY_NOTE,
    P.AGENT_VIEW,
    P.CONFIDENCE_SCORE_VIEW,
    P.LAST_TOUCH_VIEW,
    P.TAGS_VIEW,
    P.TAGS_DELETE,
    P.UNIVERSITY_VIEW,
    P.VIEW_INSTITUTION_DROPDOWN,
    P.VIEW_ACTION_DROPDOWN,
    P.STUDENT_STATUS_EDIT,
    P.STUDENTS_EXPORTS,
    P.CHECKLIST_VIEW,
    P.CHECKLIST_EDIT,
    P.CHECKLIST_FLAGS,
    P.ALL_DOCUMENTS_PREVIEW,
    P.ALL_DOCUMENTS_DOWNLOAD,
    P.ALL_DOCUMENTS_APPROVE,
    P.ALL_DOCUMENTS_REJECT,
    P.ALL_DOCUMENTS_VIEW_APPROVAL,
    P.ALL_DOCUMENTS_VIEW_REJECTION,
    P.ALL_DOCUMENTS_ACKNOWLEDGE,
    P.GENERAL_DOCUMENTS_VIEW,
    P.GENERAL_DOCUMENTS_UPLOAD,
    P.GENERAL_DOCUMENTS_FLAGS,
    P.GENERAL_DOCUMENTS_DELETE,
    P.FINANCE_DOCUMENTS_VIEW,
    P.FOLLOW_UP_DOCUMENTS_UPLOAD,
    P.FOLLOW_UP_DOCUMENTS_VIEW,
    P.FOLLOW_UP_DOCUMENTS_DELETE,
    P.FINANCE_DOCUMENTS_UPLOAD,
    P.FINANCE_DOCUMENTS_FLAGS,
    P.FINANCE_DOCUMENTS_DELETE,
    P.CUSTOM_DOCUMENTS_REQUEST,
    P.SCHEDULED_INTERVIEWS_VIEW,
    P.SCHEDULED_INTERVIEWS_ATTACH,
    P.SCHEDULED_INTERVIEWS_PREVIEW,
    P.SCHEDULED_INTERVIEWS_PASS,
    P.SCHEDULED_INTERVIEWS_RESIT,
    P.SCHEDULED_INTERVIEWS_FAIL,
    P.SCHEDULED_INTERVIEWS_REQUEST,
    P.SCHEDULED_INTERVIEWS_CANCEL,
    P.RECORDED_INTERVIEW_VIEW,
    P.RECORDED_INTERVIEW_ATTACH,
    P.RECORDED_INTERVIEW_PREVIEW,
    P.RECORDED_INTERVIEW_PASS,
    P.RECORDED_INTERVIEW_RESIT,
    P.RECORDED_INTERVIEW_FAIL,
    P.RECORDED_INTERVIEW_REQUEST,
    P.RECORDED_INTERVIEW_CANCEL,
    P.PRE_CAS_INTERVIEW_VIEW,
    P.PRE_CAS_INTERVIEW_EDIT,
    P.PRE_CAS_INTERVIEW_RESET,
    P.PRE_CAS_INTERVIEW_FLAGS,
    P.VISA_PREP_VIEW,
    P.VISA_PREP_EDIT,
    P.VISA_PREP_UNLOCK,
    P.VIEW_CONFIG,
    P.VIEW_INSIGHTS,
    P.ADVANCED_USER_MANAGEMENT,
    P.IMPORT_STUDENTS,
    P.EDIT_CONFIG,
    P.EDIT_FIELD_MAPPING,
    P.CAS_INFO_VIEW,
    P.MANAGE_AGENTS,
    P.EDIT_AGENCY_ALIASES,
    P.VIEW_ALL_DATA,
    P.EDIT_RISK_REGION,
    P.EDIT_CUSTOM_DOCUMENTS,
    P.EDIT_REGION_OFFICE,
    P.EDIT_TAGS,
    P.EDIT_PROGRAMMABLE_TAGS,
    P.VIEW_AUDIT_LOG,
    P.CHECK_OFF_RISKS,
    P.MANAGE_INTEGRATIONS,
    P.MANAGE_HOOKS,
    P.MANAGE_CALENDLY,
    P.SPECIAL_MAPS,
    P.SPECIAL_RULES,
    P.MANAGE_SYSTEM_CONFIG,
    P.VIEW_ADMIN_ACTION_DROPDOWN,
    P.UPLOAD_STAFF_ONLY_DOCS,
    P.UPLOAD_AGENT_ONLY_DOCS,
    P.RESEND_RESET_PASSWORD,
    P.EDIT_STUDENT_SERVICES,
    P.EDIT_STUDENT_IMMIGRATION_PROVIDERS,
    P.RESET_MFA,
    P.ASSIGN_VISA_SUPPORT,
    P.UNASSIGN_VISA_SUPPORT,
    P.NOT_INVITED,
    P.CAN_DELETE_FILE,
    P.LATE_ARRIVAL_VIEW,
    P.AI_INTERVIEW_ASSESSMENT_SCORES_VIEW,
    P.AI_INTERVIEW_ASSESSMENT_SCORES_EDIT,
  ],
  [UserRole.UniSecure]: [
    P.CREATE_APPLY_APPLICATION,
    P.EDIT_APPLY_SUBMITTED_APPLICANT_DETAILS,
    P.EDIT_APPLY_LOCKED_APPLICATIONS,
    P.EDIT_APPLY_OFFER,
    P.EDIT_APPLY_TAGS,
    P.VIEW_INSTITUTION_DROPDOWN,
    P.VIEW_ACTION_DROPDOWN,
    P.AGENT_VIEW,
    P.CONFIDENCE_SCORE_VIEW,
    P.LAST_TOUCH_VIEW,
    P.STUDENTS_EXPORTS,
    P.TAGS_VIEW,
    P.TAGS_DELETE,
    P.STUDENT_STATUS_EDIT,

    P.RESEND_RESET_PASSWORD,
    P.EDIT_STUDENT_SERVICES,
    P.RESET_MFA,
    P.SCHEDULED_INTERVIEWS_REQUEST,
    P.SCHEDULED_INTERVIEWS_CANCEL,
    P.CHANGE_WORKFLOW,
    P.FILTER_AGENTS,
    P.FILTER_CONFIDENCE,
    P.FILTER_SERVICES,
    P.FILTER_CONDITIONAL_STATUS,
    P.FILTER_COURSE_CONDITION_STATUS,
    P.FILTER_TAGS_STATUS,
    P.FILTER_PROG_TAGS,
    P.FILTER_RISK_REGION,
    P.FILTER_DEPENDANTS,
    P.LATE_ARRIVAL_VIEW,
    P.RECORDED_INTERVIEWS_CANCEL,
    P.EDIT_TAGS,
    P.DAYS_IN_STAGE,

    P.VIEW_INSTITUTION_DROPDOWN,
    P.VIEW_ACTION_DROPDOWN,
    P.AGENT_VIEW,
    P.CONFIDENCE_SCORE_VIEW,
    P.LAST_TOUCH_VIEW,
    P.STUDENTS_EXPORTS,
    P.TAGS_VIEW,
    P.TAGS_DELETE,
    P.STUDENT_STATUS_EDIT,
    P.PRE_CAS_INTERVIEW_VIEW,
    P.PRE_CAS_INTERVIEW_EDIT,
    P.PRE_CAS_INTERVIEW_RESET,
    P.PRE_CAS_INTERVIEW_FLAGS,
    P.CHECKLIST_VIEW,
    P.CHECKLIST_EDIT,
    P.CHECKLIST_FLAGS,
    P.ALL_DOCUMENTS_PREVIEW,
    P.ALL_DOCUMENTS_APPROVE,
    P.ALL_DOCUMENTS_REJECT,
    P.ALL_DOCUMENTS_VIEW_APPROVAL,
    P.ALL_DOCUMENTS_VIEW_REJECTION,
    P.ALL_DOCUMENTS_ACKNOWLEDGE,
    P.GENERAL_DOCUMENTS_VIEW,
    P.GENERAL_DOCUMENTS_UPLOAD,
    P.GENERAL_DOCUMENTS_FLAGS,
    P.GENERAL_DOCUMENTS_DELETE,
    P.FINANCE_DOCUMENTS_VIEW,
    P.FINANCE_DOCUMENTS_UPLOAD,
    P.FOLLOW_UP_DOCUMENTS_VIEW,
    P.FINANCE_DOCUMENTS_FLAGS,
    P.FINANCE_DOCUMENTS_DELETE,
    P.FOLLOW_UP_DOCUMENTS_UPLOAD,
    P.FOLLOW_UP_DOCUMENTS_DELETE,
    P.CUSTOM_DOCUMENTS_REQUEST,
    P.SCHEDULED_INTERVIEWS_VIEW,
    P.SCHEDULED_INTERVIEWS_ATTACH,
    P.SCHEDULED_INTERVIEWS_PREVIEW,
    P.SCHEDULED_INTERVIEWS_PASS,
    P.SCHEDULED_INTERVIEWS_RESIT,
    P.SCHEDULED_INTERVIEWS_FAIL,
    P.SCHEDULED_INTERVIEWS_REQUEST,
    P.SCHEDULED_INTERVIEWS_CANCEL,
    P.RECORDED_INTERVIEW_VIEW,
    P.RECORDED_INTERVIEW_ATTACH,
    P.RECORDED_INTERVIEW_PREVIEW,
    P.RECORDED_INTERVIEW_PASS,
    P.RECORDED_INTERVIEW_RESIT,
    P.RECORDED_INTERVIEW_FAIL,
    P.RECORDED_INTERVIEW_REQUEST,
    P.RECORDED_INTERVIEW_CANCEL,
    P.CAS_INFO_VIEW,
    P.VIEW_ALL_DATA,
    P.CHECK_OFF_RISKS,
    P.MANAGE_INTEGRATIONS,
    P.USER_MANAGEMENT,
    P.UPLOAD_STAFF_ONLY_DOCS,
    P.UPLOAD_AGENT_ONLY_DOCS,
    P.RESEND_RESET_PASSWORD,
    P.EDIT_STUDENT_SERVICES,
    P.RESET_MFA,
    P.CAN_DELETE_FILE,
    P.LATE_ARRIVAL_VIEW,
    P.AI_INTERVIEW_ASSESSMENT_SCORES_VIEW,
  ],
  [UserRole.UniAdmin]: [
    P.CREATE_APPLY_APPLICATION,
    P.EDIT_APPLY_SUBMITTED_APPLICANT_DETAILS,
    P.EDIT_APPLY_LOCKED_APPLICATIONS,
    P.EDIT_APPLY_OFFER,
    P.EDIT_APPLY_TAGS,
    P.VIEW_INSTITUTION_DROPDOWN,
    P.VIEW_ACTION_DROPDOWN,
    P.AGENT_VIEW,
    P.TAGS_VIEW,
    P.TAGS_DELETE,
    P.CONFIDENCE_SCORE_VIEW,
    P.LAST_TOUCH_VIEW,
    P.STUDENT_STATUS_EDIT,
    P.STUDENTS_EXPORTS,
    P.VIEW_CONFIG,

    P.RESEND_RESET_PASSWORD,
    P.EDIT_STUDENT_SERVICES,
    P.RESET_MFA,
    P.ASSIGN_VISA_SUPPORT,
    P.SCHEDULED_INTERVIEWS_REQUEST,
    P.SCHEDULED_INTERVIEWS_CANCEL,
    P.CHANGE_WORKFLOW,
    P.FILTER_AGENTS,
    P.FILTER_CONFIDENCE,
    P.FILTER_SERVICES,
    P.FILTER_CONDITIONAL_STATUS,
    P.FILTER_COURSE_CONDITION_STATUS,
    P.FILTER_TAGS_STATUS,
    P.FILTER_PROG_TAGS,
    P.FILTER_RISK_REGION,
    P.FILTER_DEPENDANTS,
    P.LATE_ARRIVAL_VIEW,
    P.RECORDED_INTERVIEWS_CANCEL,
    P.EDIT_TAGS,
    P.DAYS_IN_STAGE,

    // student
    P.VIEW_INSTITUTION_DROPDOWN,
    P.VIEW_ACTION_DROPDOWN,
    P.ALL_DOCUMENTS_DOWNLOAD,
    P.AGENT_VIEW,
    P.TAGS_VIEW,
    P.TAGS_DELETE,
    P.CONFIDENCE_SCORE_VIEW,
    P.LAST_TOUCH_VIEW,
    P.STUDENT_STATUS_EDIT,
    P.STUDENTS_EXPORTS,
    P.CHECKLIST_VIEW,
    P.CHECKLIST_EDIT,
    P.CHECKLIST_FLAGS,
    P.ALL_DOCUMENTS_PREVIEW,
    P.ALL_DOCUMENTS_APPROVE,
    P.ALL_DOCUMENTS_REJECT,
    P.ALL_DOCUMENTS_VIEW_APPROVAL,
    P.ALL_DOCUMENTS_VIEW_REJECTION,
    P.ALL_DOCUMENTS_ACKNOWLEDGE,
    P.GENERAL_DOCUMENTS_VIEW,
    P.GENERAL_DOCUMENTS_UPLOAD,
    P.GENERAL_DOCUMENTS_FLAGS,
    P.GENERAL_DOCUMENTS_DELETE,
    P.FINANCE_DOCUMENTS_VIEW,
    P.FINANCE_DOCUMENTS_UPLOAD,
    P.FINANCE_DOCUMENTS_FLAGS,
    P.FINANCE_DOCUMENTS_DELETE,
    P.FOLLOW_UP_DOCUMENTS_VIEW,
    P.FOLLOW_UP_DOCUMENTS_UPLOAD,
    P.FOLLOW_UP_DOCUMENTS_DELETE,
    P.CUSTOM_DOCUMENTS_REQUEST,
    P.SCHEDULED_INTERVIEWS_VIEW,
    P.SCHEDULED_INTERVIEWS_ATTACH,
    P.SCHEDULED_INTERVIEWS_PREVIEW,
    P.SCHEDULED_INTERVIEWS_PASS,
    P.SCHEDULED_INTERVIEWS_RESIT,
    P.SCHEDULED_INTERVIEWS_FAIL,
    P.SCHEDULED_INTERVIEWS_REQUEST,
    P.SCHEDULED_INTERVIEWS_CANCEL,
    P.RECORDED_INTERVIEW_VIEW,
    P.RECORDED_INTERVIEW_ATTACH,
    P.RECORDED_INTERVIEW_PREVIEW,
    P.RECORDED_INTERVIEW_PASS,
    P.RECORDED_INTERVIEW_RESIT,
    P.RECORDED_INTERVIEW_FAIL,
    P.RECORDED_INTERVIEW_REQUEST,
    P.RECORDED_INTERVIEW_CANCEL,
    P.PRE_CAS_INTERVIEW_VIEW,
    P.PRE_CAS_INTERVIEW_EDIT,
    P.PRE_CAS_INTERVIEW_RESET,
    P.PRE_CAS_INTERVIEW_FLAGS,
    P.VIEW_CONFIG,
    P.IMPORT_STUDENTS,
    P.EDIT_FIELD_MAPPING,
    P.CAS_INFO_VIEW,
    P.VIEW_ALL_DATA,
    P.EDIT_TAGS,
    P.VIEW_AUDIT_LOG,
    P.CHECK_OFF_RISKS,
    P.MANAGE_INTEGRATIONS,
    P.USER_MANAGEMENT,
    P.UPLOAD_STAFF_ONLY_DOCS,
    P.UPLOAD_AGENT_ONLY_DOCS,
    P.RESEND_RESET_PASSWORD,
    P.EDIT_STUDENT_SERVICES,
    P.RESET_MFA,
    P.ASSIGN_VISA_SUPPORT,
    P.CAN_DELETE_FILE,
    P.LATE_ARRIVAL_VIEW,
    P.AI_INTERVIEW_ASSESSMENT_SCORES_VIEW,
  ],
  [UserRole.Uni]: [
    P.CREATE_APPLY_APPLICATION,
    P.EDIT_APPLY_SUBMITTED_APPLICANT_DETAILS,
    P.EDIT_APPLY_LOCKED_APPLICATIONS,
    P.EDIT_APPLY_OFFER,
    P.EDIT_APPLY_TAGS,
    P.VIEW_INSTITUTION_DROPDOWN,
    P.VIEW_ACTION_DROPDOWN,
    P.AGENT_VIEW,
    P.CONFIDENCE_SCORE_VIEW,
    P.LAST_TOUCH_VIEW,
    P.TAGS_VIEW,
    P.TAGS_DELETE,
    P.STUDENT_STATUS_EDIT,
    P.STUDENTS_EXPORTS,
    P.RESEND_RESET_PASSWORD,
    P.EDIT_STUDENT_SERVICES,
    P.RESET_MFA,
    P.SCHEDULED_INTERVIEWS_REQUEST,
    P.SCHEDULED_INTERVIEWS_CANCEL,
    P.CHANGE_WORKFLOW,
    P.FILTER_AGENTS,
    P.FILTER_CONFIDENCE,
    P.FILTER_SERVICES,
    P.FILTER_CONDITIONAL_STATUS,
    P.FILTER_COURSE_CONDITION_STATUS,
    P.FILTER_TAGS_STATUS,
    P.FILTER_PROG_TAGS,
    P.FILTER_RISK_REGION,
    P.FILTER_DEPENDANTS,
    P.LATE_ARRIVAL_VIEW,
    P.RECORDED_INTERVIEWS_CANCEL,
    P.SCHEDULED_INTERVIEWS_REQUEST,
    P.SCHEDULED_INTERVIEWS_CANCEL,
    P.EDIT_TAGS,
    P.DAYS_IN_STAGE,

    // student
    P.VIEW_INSTITUTION_DROPDOWN,
    P.VIEW_ACTION_DROPDOWN,
    P.ALL_DOCUMENTS_DOWNLOAD,
    P.AGENT_VIEW,
    P.CONFIDENCE_SCORE_VIEW,
    P.LAST_TOUCH_VIEW,
    P.TAGS_VIEW,
    P.TAGS_DELETE,
    P.STUDENT_STATUS_EDIT,
    P.STUDENTS_EXPORTS,
    P.CHECKLIST_VIEW,
    P.CHECKLIST_EDIT,
    P.CHECKLIST_FLAGS,
    P.ALL_DOCUMENTS_PREVIEW,
    P.ALL_DOCUMENTS_APPROVE,
    P.ALL_DOCUMENTS_REJECT,
    P.ALL_DOCUMENTS_VIEW_APPROVAL,
    P.ALL_DOCUMENTS_VIEW_REJECTION,
    P.ALL_DOCUMENTS_ACKNOWLEDGE,
    P.GENERAL_DOCUMENTS_VIEW,
    P.GENERAL_DOCUMENTS_UPLOAD,
    P.GENERAL_DOCUMENTS_FLAGS,
    P.GENERAL_DOCUMENTS_DELETE,
    P.FINANCE_DOCUMENTS_VIEW,
    P.FINANCE_DOCUMENTS_UPLOAD,
    P.FINANCE_DOCUMENTS_FLAGS,
    P.FINANCE_DOCUMENTS_DELETE,
    P.FOLLOW_UP_DOCUMENTS_UPLOAD,
    P.FOLLOW_UP_DOCUMENTS_VIEW,
    P.FOLLOW_UP_DOCUMENTS_DELETE,
    P.CUSTOM_DOCUMENTS_REQUEST,
    P.SCHEDULED_INTERVIEWS_VIEW,
    P.SCHEDULED_INTERVIEWS_ATTACH,
    P.SCHEDULED_INTERVIEWS_PREVIEW,
    P.SCHEDULED_INTERVIEWS_PASS,
    P.SCHEDULED_INTERVIEWS_RESIT,
    P.SCHEDULED_INTERVIEWS_FAIL,
    P.SCHEDULED_INTERVIEWS_REQUEST,
    P.SCHEDULED_INTERVIEWS_CANCEL,
    P.RECORDED_INTERVIEW_VIEW,
    P.RECORDED_INTERVIEW_ATTACH,
    P.RECORDED_INTERVIEW_PREVIEW,
    P.RECORDED_INTERVIEW_PASS,
    P.RECORDED_INTERVIEW_RESIT,
    P.RECORDED_INTERVIEW_FAIL,
    P.RECORDED_INTERVIEW_REQUEST,
    P.RECORDED_INTERVIEW_CANCEL,
    P.PRE_CAS_INTERVIEW_VIEW,
    P.PRE_CAS_INTERVIEW_EDIT,
    P.PRE_CAS_INTERVIEW_RESET,
    P.PRE_CAS_INTERVIEW_FLAGS,
    P.CAS_INFO_VIEW,
    P.VIEW_ALL_DATA,
    P.EDIT_TAGS,
    P.CHECK_OFF_RISKS,
    P.MANAGE_INTEGRATIONS,
    P.USER_MANAGEMENT,
    P.UPLOAD_STAFF_ONLY_DOCS,
    P.UPLOAD_AGENT_ONLY_DOCS,
    P.RESEND_RESET_PASSWORD,
    P.EDIT_STUDENT_SERVICES,
    P.RESET_MFA,
    P.CAN_DELETE_FILE,
    P.LATE_ARRIVAL_VIEW,
    P.AI_INTERVIEW_ASSESSMENT_SCORES_VIEW,
  ],
  [UserRole.UniLite]: [
    P.CREATE_APPLY_APPLICATION,
    P.EDIT_APPLY_TAGS,
    P.VIEW_INSTITUTION_DROPDOWN,
    P.VIEW_ACTION_DROPDOWN,
    P.AGENT_VIEW,
    P.STUDENTS_EXPORTS,
    P.CONFIDENCE_SCORE_VIEW,
    P.TAGS_VIEW,
    P.TAGS_DELETE,
    P.RESEND_RESET_PASSWORD,
    P.RESET_MFA,
    P.SCHEDULED_INTERVIEWS_REQUEST,
    P.SCHEDULED_INTERVIEWS_CANCEL,
    P.CHANGE_WORKFLOW,
    P.FILTER_AGENTS,
    P.FILTER_CONFIDENCE,
    P.FILTER_SERVICES,
    P.FILTER_CONDITIONAL_STATUS,
    P.FILTER_COURSE_CONDITION_STATUS,
    P.FILTER_TAGS_STATUS,
    P.FILTER_PROG_TAGS,
    P.FILTER_RISK_REGION,
    P.FILTER_DEPENDANTS,
    P.LATE_ARRIVAL_VIEW,
    P.RECORDED_INTERVIEWS_CANCEL,
    P.EDIT_TAGS,
    P.DAYS_IN_STAGE,

    // student
    P.VIEW_INSTITUTION_DROPDOWN,
    P.VIEW_ACTION_DROPDOWN,
    P.AGENT_VIEW,
    P.STUDENTS_EXPORTS,
    P.CONFIDENCE_SCORE_VIEW,
    P.PRE_CAS_INTERVIEW_VIEW,
    P.PRE_CAS_INTERVIEW_FLAGS,
    P.TAGS_VIEW,
    P.TAGS_DELETE,
    P.CHECKLIST_VIEW,
    P.CHECKLIST_FLAGS,
    P.ALL_DOCUMENTS_PREVIEW,
    P.ALL_DOCUMENTS_ACKNOWLEDGE,
    P.ALL_DOCUMENTS_VIEW_APPROVAL,
    P.ALL_DOCUMENTS_VIEW_REJECTION,
    P.GENERAL_DOCUMENTS_VIEW,
    P.GENERAL_DOCUMENTS_UPLOAD,
    P.GENERAL_DOCUMENTS_FLAGS,
    P.FINANCE_DOCUMENTS_VIEW,
    P.FINANCE_DOCUMENTS_UPLOAD,
    P.FINANCE_DOCUMENTS_FLAGS,
    P.FOLLOW_UP_DOCUMENTS_VIEW,
    P.FOLLOW_UP_DOCUMENTS_UPLOAD,
    P.SCHEDULED_INTERVIEWS_VIEW,
    P.SCHEDULED_INTERVIEWS_ATTACH,
    P.SCHEDULED_INTERVIEWS_PREVIEW,
    P.SCHEDULED_INTERVIEWS_PASS,
    P.SCHEDULED_INTERVIEWS_RESIT,
    P.SCHEDULED_INTERVIEWS_FAIL,
    P.SCHEDULED_INTERVIEWS_REQUEST,
    P.SCHEDULED_INTERVIEWS_CANCEL,
    P.RECORDED_INTERVIEW_VIEW,
    P.RECORDED_INTERVIEW_ATTACH,
    P.RECORDED_INTERVIEW_PREVIEW,
    P.RECORDED_INTERVIEW_PASS,
    P.RECORDED_INTERVIEW_RESIT,
    P.RECORDED_INTERVIEW_FAIL,
    P.RECORDED_INTERVIEW_REQUEST,
    P.RECORDED_INTERVIEW_CANCEL,
    P.VIEW_ALL_DATA,
    P.MANAGE_INTEGRATIONS,
    P.USER_MANAGEMENT,
    P.UPLOAD_STAFF_ONLY_DOCS,
    P.UPLOAD_AGENT_ONLY_DOCS,
    P.RESEND_RESET_PASSWORD,
    P.RESET_MFA,
    P.LATE_ARRIVAL_VIEW,
    P.AI_INTERVIEW_ASSESSMENT_SCORES_VIEW,
  ],
  [UserRole.Agent]: [
    P.CREATE_APPLY_APPLICATION,
    P.EDIT_APPLY_APPLICANT_DETAILS,
    P.EDIT_APPLY_SUBMITTED_APPLICANT_DETAILS,
    P.EDIT_APPLY_OFFER,
    P.EDIT_APPLY_TAGS,
    P.CHANGE_WORKFLOW,
    P.UNIVERSITY_VIEW,
    P.CHECKLIST_VIEW,
    P.CHECKLIST_EDIT,
    P.CHECKLIST_NAVIGATE_FORWARD,
    P.ALL_DOCUMENTS_PREVIEW,
    P.ALL_DOCUMENTS_ACKNOWLEDGE,
    P.GENERAL_DOCUMENTS_VIEW,
    P.GENERAL_DOCUMENTS_UPLOAD,
    P.FINANCE_DOCUMENTS_VIEW,
    P.FINANCE_DOCUMENTS_UPLOAD,
    P.FOLLOW_UP_DOCUMENTS_VIEW,
    P.FOLLOW_UP_DOCUMENTS_UPLOAD,
    P.UPLOAD_AGENT_ONLY_DOCS,
    P.PRE_CAS_INTERVIEW_VIEW,
    P.VIEW_CAS_TRACKER,
    P.FILTER_SERVICES,
    P.FILTER_UNIVERSITY,
    P.DAYS_IN_STAGE,

    // student
    P.UNIVERSITY_VIEW,
    P.CHECKLIST_VIEW,
    P.CHECKLIST_EDIT,
    P.CHECKLIST_NAVIGATE_FORWARD,
    P.ALL_DOCUMENTS_PREVIEW,
    P.ALL_DOCUMENTS_ACKNOWLEDGE,
    P.ALL_DOCUMENTS_VIEW_REJECTION,
    P.GENERAL_DOCUMENTS_VIEW,
    P.GENERAL_DOCUMENTS_UPLOAD,
    P.FINANCE_DOCUMENTS_VIEW,
    P.FINANCE_DOCUMENTS_UPLOAD,
    P.FOLLOW_UP_DOCUMENTS_VIEW,
    P.FOLLOW_UP_DOCUMENTS_UPLOAD,
    P.UPLOAD_AGENT_ONLY_DOCS,
    P.SCHEDULED_INTERVIEWS_VIEW,
    P.RECORDED_INTERVIEW_VIEW,
    P.PRE_CAS_INTERVIEW_VIEW,
    P.VIEW_CAS_TRACKER,
  ],
  [UserRole.AgencyAdmin]: [
    P.CREATE_APPLY_APPLICATION,
    P.EDIT_APPLY_APPLICANT_DETAILS,
    P.EDIT_APPLY_SUBMITTED_APPLICANT_DETAILS,
    P.EDIT_APPLY_OFFER,
    P.EDIT_APPLY_TAGS,
    P.CHANGE_WORKFLOW,
    P.EDIT_OPTIONAL_AGENCY_FIELDS,
    P.UNIVERSITY_VIEW,
    P.CHECKLIST_VIEW,
    P.CHECKLIST_EDIT,
    P.CHECKLIST_NAVIGATE_FORWARD,
    P.ALL_DOCUMENTS_PREVIEW,
    P.ALL_DOCUMENTS_ACKNOWLEDGE,
    P.ALL_DOCUMENTS_VIEW_REJECTION,
    P.GENERAL_DOCUMENTS_VIEW,
    P.GENERAL_DOCUMENTS_UPLOAD,
    P.FINANCE_DOCUMENTS_VIEW,
    P.FINANCE_DOCUMENTS_UPLOAD,
    P.FOLLOW_UP_DOCUMENTS_VIEW,
    P.FOLLOW_UP_DOCUMENTS_UPLOAD,
    P.UPLOAD_AGENT_ONLY_DOCS,
    P.SCHEDULED_INTERVIEWS_VIEW,
    P.RECORDED_INTERVIEW_VIEW,
    P.PRE_CAS_INTERVIEW_VIEW,
    P.VIEW_CAS_TRACKER,
    P.MANAGE_AGENCIES,
    P.VIEW_CONFIG,
    P.FILTER_SERVICES,
    P.FILTER_UNIVERSITY,
    P.DAYS_IN_STAGE,
  ],
  [UserRole.Enroly]: [
    P.EDIT_APPLY_APPLICANT_DETAILS,
    P.EDIT_APPLY_SUBMITTED_APPLICANT_DETAILS,
    P.EDIT_APPLY_LOCKED_APPLICATIONS,
    P.EDIT_APPLY_OFFER,
    P.EDIT_APPLY_TAGS,
    P.EDIT_OPTIONAL_AGENCY_FIELDS,
    P.ADD_AGENCY_NOTE,
    P.VIEW_INSTITUTION_DROPDOWN,
    P.VIEW_ACTION_DROPDOWN,
    P.AGENT_VIEW,
    P.CONFIDENCE_SCORE_VIEW,
    P.LAST_TOUCH_VIEW,
    P.TAGS_VIEW,
    P.TAGS_DELETE,
    P.UNIVERSITY_VIEW,
    P.MULTI_UNIVERSITY_VIEW,
    P.STUDENT_STATUS_EDIT,
    P.STUDENTS_EXPORTS,
    P.CHECKLIST_VIEW,
    P.CHECKLIST_EDIT,
    P.CHECKLIST_FLAGS,
    P.ALL_DOCUMENTS_PREVIEW,
    P.ALL_DOCUMENTS_DOWNLOAD,
    P.ALL_DOCUMENTS_ACKNOWLEDGE,
    P.ALL_DOCUMENTS_VIEW_APPROVAL,
    P.ALL_DOCUMENTS_VIEW_REJECTION,
    P.GENERAL_DOCUMENTS_VIEW,
    P.GENERAL_DOCUMENTS_UPLOAD,
    P.GENERAL_DOCUMENTS_FLAGS,
    P.GENERAL_DOCUMENTS_DELETE,
    P.FINANCE_DOCUMENTS_VIEW,
    P.FINANCE_DOCUMENTS_UPLOAD,
    P.FINANCE_DOCUMENTS_FLAGS,
    P.FINANCE_DOCUMENTS_DELETE,
    P.FOLLOW_UP_DOCUMENTS_VIEW,
    P.FOLLOW_UP_DOCUMENTS_UPLOAD,
    P.FOLLOW_UP_DOCUMENTS_DELETE,
    P.CUSTOM_DOCUMENTS_REQUEST,
    P.SCHEDULED_INTERVIEWS_VIEW,
    P.SCHEDULED_INTERVIEWS_REQUEST,
    P.SCHEDULED_INTERVIEWS_ATTACH,
    P.SCHEDULED_INTERVIEWS_PREVIEW,
    P.SCHEDULED_INTERVIEWS_PASS,
    P.SCHEDULED_INTERVIEWS_RESIT,
    P.SCHEDULED_INTERVIEWS_FAIL,
    P.SCHEDULED_INTERVIEWS_CANCEL,
    P.RECORDED_INTERVIEW_VIEW,
    P.RECORDED_INTERVIEW_ATTACH,
    P.RECORDED_INTERVIEW_PREVIEW,
    P.RECORDED_INTERVIEW_PASS,
    P.RECORDED_INTERVIEW_RESIT,
    P.RECORDED_INTERVIEW_FAIL,
    P.RECORDED_INTERVIEW_REQUEST,
    P.RECORDED_INTERVIEW_CANCEL,
    P.PRE_CAS_INTERVIEW_VIEW,
    P.PRE_CAS_INTERVIEW_EDIT,
    P.PRE_CAS_INTERVIEW_RESET,
    P.PRE_CAS_INTERVIEW_FLAGS,
    P.VISA_PREP_VIEW,
    P.VISA_PREP_EDIT,
    P.VISA_PREP_UNLOCK,
    P.CAS_INFO_VIEW,
    P.MANAGE_AGENTS,
    P.EDIT_AGENCY_ALIASES,
    P.ADVANCED_USER_MANAGEMENT,
    P.VIEW_ALL_DATA,
    P.EDIT_CONFIG,
    P.EDIT_RISK_REGION,
    P.EDIT_CUSTOM_DOCUMENTS,
    P.EDIT_REGION_OFFICE,
    P.EDIT_TAGS,
    P.EDIT_PROGRAMMABLE_TAGS,
    P.VIEW_AUDIT_LOG,
    P.CHECK_OFF_RISKS,
    P.MANAGE_INTEGRATIONS,
    P.MANAGE_CALENDLY,
    P.SPECIAL_MAPS,
    P.SPECIAL_RULES,
    P.MANAGE_SYSTEM_CONFIG,
    P.VIEW_ADMIN_ACTION_DROPDOWN,
    P.UPLOAD_STAFF_ONLY_DOCS,
    P.UPLOAD_AGENT_ONLY_DOCS,
    P.RESEND_RESET_PASSWORD,
    P.EDIT_STUDENT_SERVICES,
    P.EDIT_STUDENT_IMMIGRATION_PROVIDERS,
    P.RESET_MFA,
    P.ASSIGN_VISA_SUPPORT,
    P.UNASSIGN_VISA_SUPPORT,
    P.CAN_DELETE_FILE,
    P.LATE_ARRIVAL_VIEW,
    P.AI_INTERVIEW_ASSESSMENT_SCORES_VIEW,
    P.AI_INTERVIEW_ASSESSMENT_SCORES_EDIT,
    P.SCHEDULED_INTERVIEWS_REQUEST,
    P.SCHEDULED_INTERVIEWS_CANCEL,
    P.FILTER_AGENTS,
    P.FILTER_CONFIDENCE,
    P.FILTER_SERVICES,
    P.FILTER_IMM_PROV,
    P.FILTER_CONDITIONAL_STATUS,
    P.FILTER_COURSE_CONDITION_STATUS,
    P.FILTER_TAGS_STATUS,
    P.FILTER_PROG_TAGS,
    P.FILTER_UNIVERSITY,
    P.FILTER_RISK_REGION,
    P.FILTER_DEPENDANTS,
    P.LATE_ARRIVAL_VIEW,
    P.RECORDED_INTERVIEWS_CANCEL,
    P.NOT_INVITED,
    P.DAYS_IN_STAGE,
  ],
  [UserRole.Partner]: [
    P.CREATE_APPLY_APPLICATION,
    P.EDIT_APPLY_SUBMITTED_APPLICANT_DETAILS,
    P.EDIT_APPLY_OFFER,
    P.EDIT_APPLY_TAGS,
    P.AGENT_VIEW,
    P.CONFIDENCE_SCORE_VIEW,
    P.PRE_CAS_INTERVIEW_VIEW,
    P.PRE_CAS_INTERVIEW_FLAGS,
    P.TAGS_VIEW,
    P.UNIVERSITY_VIEW,
    P.CHECKLIST_VIEW,
    P.CHECKLIST_FLAGS,
    P.ALL_DOCUMENTS_ACKNOWLEDGE,
    P.ALL_DOCUMENTS_VIEW_REJECTION,
    P.GENERAL_DOCUMENTS_VIEW,
    P.GENERAL_DOCUMENTS_UPLOAD,
    P.GENERAL_DOCUMENTS_FLAGS,
    P.FINANCE_DOCUMENTS_VIEW,
    P.FINANCE_DOCUMENTS_UPLOAD,
    P.FINANCE_DOCUMENTS_FLAGS,
    P.FOLLOW_UP_DOCUMENTS_VIEW,
    P.FOLLOW_UP_DOCUMENTS_UPLOAD,
    P.VIEW_ALL_DATA,
    P.MANAGE_INTEGRATIONS,
    P.USER_MANAGEMENT,
    P.UPLOAD_STAFF_ONLY_DOCS,
    P.UPLOAD_AGENT_ONLY_DOCS,
    P.FILTER_AGENTS,
    P.FILTER_CONFIDENCE,
    P.FILTER_CONDITIONAL_STATUS,
    P.FILTER_COURSE_CONDITION_STATUS,
    P.FILTER_TAGS_STATUS,
    P.FILTER_PROG_TAGS,
    P.FILTER_UNIVERSITY,
    P.DAYS_IN_STAGE,
    P.CHANGE_WORKFLOW,

    // student
    P.AGENT_VIEW,
    P.CONFIDENCE_SCORE_VIEW,
    P.PRE_CAS_INTERVIEW_VIEW,
    P.PRE_CAS_INTERVIEW_FLAGS,
    P.TAGS_VIEW,
    P.CHECKLIST_VIEW,
    P.CHECKLIST_FLAGS,
    P.ALL_DOCUMENTS_ACKNOWLEDGE,
    P.GENERAL_DOCUMENTS_VIEW,
    P.GENERAL_DOCUMENTS_UPLOAD,
    P.GENERAL_DOCUMENTS_FLAGS,
    P.FINANCE_DOCUMENTS_VIEW,
    P.FINANCE_DOCUMENTS_UPLOAD,
    P.FINANCE_DOCUMENTS_FLAGS,
    P.FOLLOW_UP_DOCUMENTS_VIEW,
    P.FOLLOW_UP_DOCUMENTS_UPLOAD,
    P.SCHEDULED_INTERVIEWS_VIEW,
    P.RECORDED_INTERVIEW_VIEW,
    P.SCHEDULED_INTERVIEWS_ATTACH,
    P.VIEW_ALL_DATA,
    P.MANAGE_INTEGRATIONS,
    P.USER_MANAGEMENT,
    P.UPLOAD_STAFF_ONLY_DOCS,
    P.UPLOAD_AGENT_ONLY_DOCS,
    P.AI_INTERVIEW_ASSESSMENT_SCORES_VIEW,
  ],
  [UserRole.ImmigrationProvider]: [
    P.CREATE_APPLY_APPLICATION,
    P.EDIT_APPLY_SUBMITTED_APPLICANT_DETAILS,
    P.EDIT_APPLY_OFFER,
    P.EDIT_APPLY_TAGS,
    P.VIEW_INSTITUTION_DROPDOWN,
    P.VIEW_ACTION_DROPDOWN,
    P.AGENT_VIEW,
    P.CONFIDENCE_SCORE_VIEW,
    P.LAST_TOUCH_VIEW,
    P.TAGS_VIEW,
    P.TAGS_DELETE,
    P.UNIVERSITY_VIEW,
    P.MULTI_UNIVERSITY_VIEW,
    P.STUDENT_STATUS_EDIT,
    P.SCHEDULED_INTERVIEWS_REQUEST,
    P.SCHEDULED_INTERVIEWS_CANCEL,
    P.FILTER_AGENTS,
    P.FILTER_CONFIDENCE,
    P.FILTER_CONDITIONAL_STATUS,
    P.FILTER_COURSE_CONDITION_STATUS,
    P.FILTER_TAGS_STATUS,
    P.FILTER_PROG_TAGS,
    P.FILTER_DEPENDANTS,
    P.RECORDED_INTERVIEWS_CANCEL,
    P.FILTER_UNIVERSITY,
    P.DAYS_IN_STAGE,

    //student
    P.VIEW_INSTITUTION_DROPDOWN,
    P.VIEW_ACTION_DROPDOWN,
    P.AGENT_VIEW,
    P.CONFIDENCE_SCORE_VIEW,
    P.LAST_TOUCH_VIEW,
    P.TAGS_VIEW,
    P.TAGS_DELETE,
    P.UNIVERSITY_VIEW,
    P.STUDENT_STATUS_EDIT,
    P.CHECKLIST_VIEW,
    P.CHECKLIST_EDIT,
    P.CHECKLIST_FLAGS,
    P.ALL_DOCUMENTS_PREVIEW,
    P.ALL_DOCUMENTS_DOWNLOAD,
    P.ALL_DOCUMENTS_ACKNOWLEDGE,
    P.ALL_DOCUMENTS_VIEW_APPROVAL,
    P.ALL_DOCUMENTS_VIEW_REJECTION,
    P.GENERAL_DOCUMENTS_VIEW,
    P.GENERAL_DOCUMENTS_UPLOAD,
    P.GENERAL_DOCUMENTS_FLAGS,
    P.GENERAL_DOCUMENTS_DELETE,
    P.FINANCE_DOCUMENTS_VIEW,
    P.FINANCE_DOCUMENTS_UPLOAD,
    P.FINANCE_DOCUMENTS_FLAGS,
    P.FINANCE_DOCUMENTS_DELETE,
    P.FOLLOW_UP_DOCUMENTS_VIEW,
    P.FOLLOW_UP_DOCUMENTS_UPLOAD,
    P.FOLLOW_UP_DOCUMENTS_DELETE,
    P.CUSTOM_DOCUMENTS_REQUEST,
    P.SCHEDULED_INTERVIEWS_VIEW,
    P.SCHEDULED_INTERVIEWS_ATTACH,
    P.SCHEDULED_INTERVIEWS_PREVIEW,
    P.SCHEDULED_INTERVIEWS_PASS,
    P.SCHEDULED_INTERVIEWS_RESIT,
    P.SCHEDULED_INTERVIEWS_FAIL,
    P.SCHEDULED_INTERVIEWS_REQUEST,
    P.SCHEDULED_INTERVIEWS_CANCEL,
    P.RECORDED_INTERVIEW_VIEW,
    P.RECORDED_INTERVIEW_ATTACH,
    P.RECORDED_INTERVIEW_PREVIEW,
    P.RECORDED_INTERVIEW_PASS,
    P.RECORDED_INTERVIEW_RESIT,
    P.RECORDED_INTERVIEW_FAIL,
    P.RECORDED_INTERVIEW_REQUEST,
    P.RECORDED_INTERVIEW_CANCEL,
    P.PRE_CAS_INTERVIEW_VIEW,
    P.PRE_CAS_INTERVIEW_RESET,
    P.PRE_CAS_INTERVIEW_FLAGS,
    P.VISA_PREP_VIEW,
    P.VISA_PREP_EDIT,
    P.VISA_PREP_UNLOCK,
    P.CAS_INFO_VIEW,
    P.VIEW_ALL_DATA,
    P.VIEW_AUDIT_LOG,
    P.UPLOAD_STAFF_ONLY_DOCS,
    P.UPLOAD_AGENT_ONLY_DOCS,
    P.CAN_DELETE_FILE,
    P.AI_INTERVIEW_ASSESSMENT_SCORES_VIEW,
  ],
  [UserRole.Unknown]: [],
};

export const ServiceProviderOverrides: Record<ServiceProviderType, P[]> = {
  IA: [
    P.ALL_DOCUMENTS_PREVIEW,
    P.ALL_DOCUMENTS_DOWNLOAD,
    P.AI_INTERVIEW_ASSESSMENT_SCORES_VIEW,
    P.AI_INTERVIEW_ASSESSMENT_SCORES_EDIT,
    P.RECORDED_INTERVIEW_VIEW,
    P.SCHEDULED_INTERVIEWS_PREVIEW,
  ],
  VT: [],
  AT: [],
  CT: [],
  BC: [],
};

export const hasPerm = (role: UserRole, permission: P, serviceProviderType?: ServiceProviderType): boolean => {
  if (
    role === UserRole.Partner &&
    serviceProviderType &&
    ServiceProviderOverrides[serviceProviderType]?.includes(permission)
  ) {
    return true;
  }
  return Permissions[role]?.includes(permission);
};

export const isAgentRole = (role: UserRole): boolean => {
  return role === UserRole.Agent;
};

export const isAgentOrAgencyRole = (role: UserRole): boolean => {
  return [UserRole.Agent, UserRole.AgencyAdmin].includes(role);
};

export const isEnrolyStaff = (role: UserRole): boolean => [UserRole.Admin, UserRole.Enroly].includes(role);

export const isPartnerRole = (role: UserRole): boolean => {
  return role === UserRole.Partner;
};

export const isUniStaffRole = (role: UserRole): boolean => {
  return [UserRole.Uni, UserRole.UniAdmin, UserRole.UniLite, UserRole.UniSecure].includes(role);
};

export const isAdminRole = (role: UserRole): boolean => {
  return role === UserRole.Admin;
};

/**
 * Returns a list of universities available to an agent based on their assigned universities
 * and block list
 */
export const getAgentAvailableUniversities = (
  authAgencyData: {
    assignedUnis?: string[];
    blockCreateApplicationUnis?: string[];
  },
  configUniIds: Array<{ value: string; label: string }>,
  configUrls: IUrls,
): Array<{ value: string; label: string }> => {
  // If we don't have the necessary data yet, don't return any
  if (!authAgencyData?.assignedUnis || !configUniIds?.length) {
    return [];
  }

  const blockList = authAgencyData.blockCreateApplicationUnis || [];
  const isBlockedAll = Array.isArray(blockList) ? blockList.includes('ALL') : blockList === 'ALL';

  if (isBlockedAll) {
    return [];
  }

  // Filter assigned universities that aren't blocked
  const filteredUnis =
    authAgencyData?.assignedUnis?.filter(uni => !Array.isArray(blockList) || !blockList.includes(uni)) ?? [];

  // Get the university options that match our filtered IDs and have URLs in config
  const eligibleUniversities = configUniIds
    .filter(uni => {
      const isAssigned = filteredUnis.includes(uni.value);
      const hasUrl = Boolean(configUrls[uni.value]?.apply);
      return isAssigned && hasUrl;
    })
    .sort((a, b) => a.label.localeCompare(b.label));

  // Fallback: If no universities are eligible but the drawer was shown,
  // show all universities that have URLs in the config
  if (eligibleUniversities.length === 0) {
    return [];
  }

  return eligibleUniversities;
};
